import axios from 'axios';
import { getToken, clearSession } from '../auth/session';

const BASE_URL = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/+$/, '');

const client = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

// Attach the Passport bearer token to every request that has one.
client.interceptors.request.use(function (config) {
  const token = getToken();
  if (token) {
    config.headers.Authorization = 'Bearer ' + token;
  }
  return config;
});

// A 401 on any authenticated call means the token is dead (expired, revoked,
// or the account was deleted elsewhere) — drop the session immediately.
client.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    const status = error.response && error.response.status;
    const isLoginCall =
      error.config && String(error.config.url).indexOf('login') !== -1;

    if (status === 401 && !isLoginCall) {
      clearSession();
    }
    return Promise.reject(error);
  }
);

export default client;
